// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fs-a";
export var fulfillmentFormRail = "_fs-9";
export var headerTitleRow = "_fs-c";
export var orderDetailsWrapper = "_fs-7";
export var orderLinkTrigger = "_fs-2";
export var paymentInformationGrid = "_fs-h";
export var paymentSummaryColumn = "_fs-i";
export var shipmentContainer = "_fs-b";
export var shipmentDetailsMainPane = "_fs-8";
export var shipmentNavigationCard = "_fs-5";
export var shipmentNavigationRail = "_fs-3";
export var shipmentNavigationRailHeader = "_fs-4";
export var shipmentSummaryFact = "_fs-e";
export var shipmentSummaryGrid = "_fs-d";
export var shipmentSummaryMetadataRow = "_fs-f";
export var shipmentSummaryTags = "_fs-g";
export var shipmentWorkspace = "_fs-0";
export var shipmentWorkspaceContent = "_fs-6";
export var shipmentWorkspaceHeader = "_fs-1";